import { localStorageWrapper } from '../../helpers/localStorage'

/**
 * まもるNotion UI刷新の移行flag判定。 yakureki-front の use_legacy_ui 慣習に合わせ、
 * 未設定(ログイン前・旧ログインレスポンス未取得)は既定で legacy 扱い(= true)にする。
 *
 * frontend/backendは別々にdeployされるため、backendがまだuse_legacy_uiを返さない
 * (ロールアウト前・別ブランチ)期間は login.tsx が `undefined` を保存し得る。
 * `JSON.stringify(undefined)` は不正なJSON文字列"undefined"になり読み出し時に
 * JSON.parseが例外を投げるため、ここで吸収してlegacy既定にフォールバックする。
 * 一次情報: hub/log/46_20260701_mamoru_notion_uiux_redesign_plan
 */
export const isLegacyUi = (): boolean => {
  try {
    const stored = localStorageWrapper.getItem('use_legacy_ui')
    return stored === null || stored === undefined ? true : stored
  } catch {
    return true
  }
}
